/**
 * DevExtreme (esm/ui/date_box/ui.date_box.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../core/component_registrator";
import DateBoxMask from "./ui.date_box.mask";
registerComponent("dxDateBox", DateBoxMask);
export default DateBoxMask;
